import React from 'react';
import { assessmentPromptsPathName, dialogPromptsPathName, glossaryPathName, municipalDocumentsPathName, standardQuestionsListPathName } from './ai-pathnames';
import { TenantAddonConstants, useTenantAddons } from '../../../components/tenant-addons';
import { ResourceTypes, ResourceOperations } from '../../../authentication/resources';
import { Restricted } from '../../../authentication';
import { useIsAllowed } from '../../../authentication/use-is-allowed';
import { AdminHeaderLink, AdminRouterLink } from '../components/admin-area-menu-links';
import { joinURL } from '../../../utilities';
import { adminAreaPathName, aiTabLabel, aiTabPathName } from '../admin-area-pathnames';
import { useAiAssistantAvailability } from '../../../hooks/ai-search/use-ai-assistant-availability';
import { useAiDemoEmailDomainAccess } from '../../../hooks/ai-search/use-ai-demo-email-domain-access';

export function AiMenu() {
  const { isTenantAddonEnabled } = useTenantAddons();
  const { aiFasitAssistant } = useAiAssistantAvailability();
  const { isAiDemoEmailDomainAllowed } = useAiDemoEmailDomainAccess();
  const hasMunicipalDocuments = aiFasitAssistant.enabled && isAiDemoEmailDomainAllowed;
  const hasDialogSupport = isTenantAddonEnabled(['Dialogstøtte']);
  const canReadAssessmentPrompts = useIsAllowed([{ resourceType: ResourceTypes.AssessmentPrompts, resourceOperation: ResourceOperations.Read }]);
  const hasAssessmentPrompts = isTenantAddonEnabled([TenantAddonConstants.VumDialogSupport]) && canReadAssessmentPrompts;
  const hasGlossary = isTenantAddonEnabled(['Tolkebistand']);

  return (
    <Restricted denied=" " actions={[{ resourceType: ResourceTypes.FasitAdministration, resourceOperation: ResourceOperations.Access }]}>
      <AdminHeaderLink to={joinURL('/', adminAreaPathName, aiTabPathName)}>{aiTabLabel}</AdminHeaderLink>
      <AdminRouterLink to={joinURL('/', adminAreaPathName, aiTabPathName, standardQuestionsListPathName)}>Standard spørgsmål</AdminRouterLink>
      {hasMunicipalDocuments && <AdminRouterLink to={joinURL('/', adminAreaPathName, aiTabPathName, municipalDocumentsPathName)}>Egne dokumenter</AdminRouterLink>}
      {hasDialogSupport && <AdminRouterLink to={joinURL('/', adminAreaPathName, aiTabPathName, dialogPromptsPathName)}>Dialogstøtte</AdminRouterLink>}
      {hasAssessmentPrompts && <AdminRouterLink to={joinURL('/', adminAreaPathName, aiTabPathName, assessmentPromptsPathName)}>Støttevurderinger</AdminRouterLink>}
      {hasGlossary && <AdminRouterLink to={joinURL('/', adminAreaPathName, aiTabPathName, glossaryPathName)}>Fagtermer</AdminRouterLink>}
    </Restricted>
  );
}
